import { render, staticRenderFns } from "./ProjectUserStat.vue?vue&type=template&id=7c07648e&scoped=true&"
import script from "./ProjectUserStat.vue?vue&type=script&lang=js&"
export * from "./ProjectUserStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c07648e",
  null
  
)

export default component.exports